import { httpClient } from "@/lib/http-client"

export class Action {
  constructor(id: string, name: string, siteId: string, featureTypeId: string | null, featureId: string | null, projectId: string | null, priorityCodeId: string, statusCodeId: string, startDate: string | null, endDate: string | null, assignedUserId: string | null, description: string | undefined) {
    this.id = id
    this.name = name
    this.siteId = siteId
    this.description = description
    this.featureTypeId = featureTypeId
    this.featureId = featureId
    this.projectId = projectId
    this.priorityCodeId = priorityCodeId
    this.statusCodeId = statusCodeId
    this.startDate = startDate
    this.endDate = endDate
    this.assignedUserId = assignedUserId
  }

  id: string
  name: string
  siteId: string
  description: string | undefined
  featureTypeId: string | null
  featureId: string | null
  projectId: string | null
  priorityCodeId: string
  statusCodeId: string
  startDate: string | null
  endDate: string | null
  assignedUserId: string | null
  projectName: string | null = null
  assignedUserName: string | null = null
  featureName: string | null = null
}

export class ActionService {
  private static readonly BASE_PATH = "/api/actions"

  static create(action: Action): Promise<Action> {
    return httpClient
      .post<Action>(this.BASE_PATH, action)
  }  

  static getByFeatureId(featureId: string): Promise<Action[]> {
    return httpClient
      .get<Action[]>(`${this.BASE_PATH}/list/feature/${featureId}`)
  }

  static getByFeatureTypeId(featureTypeId: string): Promise<Action[]> {
    return httpClient
      .get<Action[]>(`${this.BASE_PATH}/featuretypes/${featureTypeId}`)
  }  

  static getByProjectId(projectId: string): Promise<Action[]> {
    return httpClient
      .get<Action[]>(`${this.BASE_PATH}/projects/${projectId}`)
  }

  static getByAreaId(areaId: string): Promise<Action[]> {
    return httpClient
      .get<Action[]>(`${this.BASE_PATH}/area/${areaId}`)
  }

  static getByASiteId(siteId: string): Promise<Action[]> {
    return httpClient
      .get<Action[]>(`${this.BASE_PATH}/sites/${siteId}`)
  }

  static getById(actionId: string): Promise<Action> {
    return httpClient
      .get<Action>(`${this.BASE_PATH}/${actionId}`)
  }

  static update(actionId: string, action: Action): Promise<Action> {
    return httpClient
      .put<Action>(`${this.BASE_PATH}/${actionId}`, action)
  }

  static delete(actionId: string): Promise<void> {
    return httpClient
      .delete(`${this.BASE_PATH}/${actionId}`)
  }
}